import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: "SpringLinks transformed our operations with their AI solutions. The team's deep understanding of African business challenges sets them apart.",
    author: 'James Mwangi',
    title: 'CTO, EastAfrica Financial Group'
  }, {
    quote: 'Their intelligent automation platform saved us thousands of hours annually. Exceptional delivery and support from start to finish.',
    author: 'Amina Hassan',
    title: 'VP Operations, Savanna Logistics'
  }, {
    quote: 'The generative AI solution SpringLinks built for us has revolutionized how we engage with customers. Truly a game-changer.',
    author: 'David Ochieng',
    title: 'CEO, ConnectAfrica Telecom'
  }];
  return <section className="py-24 bg-[#1e1b1c] relative" data-id="element-191">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-192">
        <div className="text-center mb-16" data-id="element-193">
          <div className="inline-flex items-center justify-center gap-2 mb-4" data-id="element-194">
            <div className="w-8 h-1 bg-brand-primary rounded-full" data-id="element-195"></div>
            <h2 className="text-brand-primary font-semibold uppercase tracking-wider text-sm" data-id="element-196">
              What Our Clients Say
            </h2>
            <div className="w-8 h-1 bg-brand-primary rounded-full" data-id="element-197"></div>
          </div>
          <h3 className="text-3xl md:text-5xl font-bold text-white" data-id="element-198">
            Trusted by Enterprise Leaders
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-199">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="glass-card p-8 rounded-2xl relative" data-id="element-200">
              <QuoteIcon className="absolute top-6 right-6 w-12 h-12 text-brand-primary/20" data-id="element-201" />

              <div className="flex gap-1 mb-6" data-id="element-202">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-brand-primary text-brand-primary" data-id="element-203" />)}
              </div>

              <p className="text-gray-300 text-lg italic mb-8 relative z-10 leading-relaxed" data-id="element-204">
                "{testimonial.quote}"
              </p>

              <div className="mt-auto" data-id="element-205">
                <h5 className="text-white font-bold text-lg" data-id="element-206">
                  {testimonial.author}
                </h5>
                <p className="text-brand-primary text-sm" data-id="element-207">
                  {testimonial.title}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}